var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWithdrawal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.04 2H1.44C1.3127 2 1.19061 1.94732 1.10059 1.85355C1.01057 1.75979 0.96 1.63261 0.96 1.5C0.96 1.36739 1.01057 1.24021 1.10059 1.14645C1.19061 1.05268 1.3127 1 1.44 1H9.6C9.7273 1 9.84939 0.947321 9.93941 0.853553C10.0294 0.759785 10.08 0.632608 10.08 0.5C10.08 0.367392 10.0294 0.240215 9.93941 0.146447C9.84939 0.0526785 9.7273 0 9.6 0H1.44C1.05822 0.000454899 0.692206 0.158636 0.422249 0.439842C0.152291 0.721048 0.000436703 1.10231 0 1.5V9.5C0.000436703 9.89769 0.152291 10.279 0.422249 10.5602C0.692206 10.8414 1.05822 10.9995 1.44 11H11.04C11.2945 10.9997 11.5385 10.8942 11.7185 10.7068C11.8985 10.5193 11.9997 10.2651 12 10V3C11.9997 2.73488 11.8985 2.4807 11.7185 2.29323C11.5385 2.10576 11.2945 2.0003 11.04 2ZM8.88 7.25C8.7376 7.25 8.59839 7.20601 8.47999 7.1236C8.36159 7.04119 8.2693 6.92406 8.21481 6.78701C8.16031 6.64997 8.14605 6.49917 8.17383 6.35368C8.20162 6.2082 8.27019 6.07456 8.37088 5.96967C8.47158 5.86478 8.59987 5.79335 8.73954 5.76441C8.8792 5.73547 9.02397 5.75033 9.15553 5.80709C9.28709 5.86386 9.39954 5.95999 9.47866 6.08332C9.55777 6.20666 9.6 6.35166 9.6 6.5C9.6 6.69891 9.52414 6.88968 9.38912 7.03033C9.25409 7.17098 9.07096 7.25 8.88 7.25Z",
    fill: "#8D8EA2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawal);
export default __webpack_public_path__ + "static/media/withdrawal.6deaaeed6bf25674d5c804823dc8bf9f.svg";
export { ForwardRef as ReactComponent };